import { h } from 'preact'
import Icon from '../assets'

interface Props {
  onClick: () => void,
  className?: string,
  numberOfVotes: number,
  currentUserVoted: boolean
}

const TopicVote = ({ onClick, className = '', numberOfVotes, currentUserVoted }: Props) => {
  return (
    <button className={`thread-meta-item btn--toggle thread-meta-item--vote qa-topic-meta-likes-icon ${currentUserVoted ? 'preact_voted' : ''} ${className}`} onClick={onClick}>
      <span className='qa-topic-meta-likes-content'>{numberOfVotes}</span>
      <Icon
        icon='triangle'
        width={10}
        height={8}
      />
    </button>
  )
}

export default TopicVote
